export const services = [
    "Work Contracts and Visas for Canada, Poland, Ireland, Albania etc.",
	"Translation services", 
	"Reservation and sales of flight Tickets",
	"Sales and recharge of VISA cards",
	"Visa card online payment services",
	"Housing services abroad",
	"Airport assistance and pick-up services in Cameroon and  abroad",
	"Tourist or visitors visa assistance" 
];